/* eslint-disable */
import { ajax } from "./ajax.js";
import unit from './common';
/*
  彩蛋 祝你身体健康  
*/
export default {
  install(Vue) {
    Vue.prototype.$Ajax = ajax
    Vue.prototype.$common = unit;
  },
} 